export default __webpack_public_path__ + "static/media/actoctt-medium-webfont.ff81e4b6.woff";